<div style='text-align:center'>
  <h1>Rechazado</h1>

  <h2>{{data.datos.RespuestaWebpay.motivo}}</h2>

  <p-table [value]="[{}]" class="tablawidth">
    <ng-template pTemplate="body">
      <tr>
        <td>Orden de compra:</td>
        <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.buy_order }}</td>
      </tr>
      <tr>
        <td>Id de sesión:</td>
        <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.session_id }}</td>
      </tr>
      <tr>
        <td>Monto:</td>
        <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.amount }}</td>
      </tr>
      <tr>
        <td>Final número de tarjeta:</td>
        <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.card_detail.card_number }}</td>
      </tr>
      <tr>
        <td>Tipo de pago:</td>
        <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.payment_type_code }}</td>
      </tr>
      <tr>
        <td>Cuotas:</td>
        <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.installments_number }}</td>
      </tr>
    </ng-template>
  </p-table>

  <div>
    <div>
      <p>
        Los rechazos no provienen de la Universidad,
        siempre debe consultar a su Banco por estos problemas.
      </p>

      <p>
        Si existe descuento en su Banco, éste monto no llega a la
        Universidad, las reversas pueden demorar hasta 72 horas.
      </p>

      <p>
        Para dudas o consultas de WebPay acerca del pago, boleta, devolución o
        reembolsos, etc; comuníquese ingresando a https://aranceles.uv.cl, también
        a través del email finanzas.recaudacion@uv.cl o al fono (032) 2507237.
      </p>
    </div>
    <br /><br />
    <div>
      <button pButton type="button" label="Volver" (click)="volver()" class="me-1 p-button-sm"></button>
    </div>
  </div>
</div>